let salesForm = document.querySelector('.sales-form');
let intervals = document.querySelectorAll('input[name="Interval"]');

if (intervals.length && !salesForm) {
    let interval = null;
    let selectHousing = document.querySelector('select[name="HouseType"]');
    let selectHousingVal = selectHousing.value;
    let showFields = false;
    let preCheckedInterval = null;

    // Fields to show/hide
    let monthlyExpenses = document.querySelector('input[name="MonthlyExpenses"]'),
        rent = document.querySelector('input[name="Rent"]'),
        bankAccount = document.querySelector('.bank-account'),
        housingBenefit = document.querySelector('.housing-benefit');

    if (monthlyExpenses) {
        //monthlyExpenses.closest('.input-group').style.display = 'none';
        //rent.closest('.input-group').style.display = 'none';
        //if (housingBenefit) {
        //    housingBenefit.closest('.input-group').style.display = 'none';
        //    housingBenefit.style.display = "none";
        //}
        //bankAccount.style.display = 'none';

        for (let i = 0; i < intervals.length; i++) {
            if (intervals[i].checked) {
                preCheckedInterval = intervals[i].dataset.intervalindex;

                if (preCheckedInterval >= 3) {
                    showFields = true;
                } else {
                    showFields = false;
                }
            }
            intervals[i].addEventListener("change", function () {
                preCheckedInterval = this.dataset.intervalindex;

                if (preCheckedInterval >= 3) {
                    showFields = true;
                } else {
                    showFields = false;
                }

                if (selectHousingVal && selectHousingVal != "notvalid") {
                    formShowFields(selectHousingVal)
                }
            });
        }

        selectHousing.addEventListener('change', function() {
            selectHousingVal = this.value;
            formShowFields(selectHousingVal);
        });
    }


    function formShowFields(housing) {
        if (housing == "1" || housing == "2" ) {
            monthlyExpenses.closest('.input-group').style.display = 'none';
            rent.closest('.input-group').style.display = 'none';
            if (housingBenefit) {
                housingBenefit.closest('.input-group').style.display = 'none';
            }

            bankAccount.style.display = 'none';
           
            return;

        } else {
            if (showFields && preCheckedInterval != 2 || showFields && preCheckedInterval != 1) {
                rent.closest('.input-group').style.display = 'flex';
                if (housingBenefit) {
                    housingBenefit.closest('.input-group').style.display = 'flex';
                }

                // Hide fields
                bankAccount.style.display = 'none';
                monthlyExpenses.closest('.input-group').style.display = 'none';

            }

            if (preCheckedInterval == 2) {

                //show fields if interval is 2
                monthlyExpenses.closest('.input-group').style.display = 'none'
                //bankAccount.style.display = 'block';
                rent.closest('.input-group').style.display = 'flex';
                if (housingBenefit) {
                    housingBenefit.closest('.input-group').style.display = 'flex';
                }


            }

            if (!showFields && preCheckedInterval <= 3) {
                rent.closest('.input-group').style.display = 'flex';
                if (housingBenefit) {
                    housingBenefit.closest('.input-group').style.display = 'flex';
                }

                bankAccount.style.display = 'block';
                monthlyExpenses.closest('.input-group').style.display = 'flex';
            }
        }
    }
}
